import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { PATHS } from "../constant";
import GroupManagement from "../container/GroupManagement";
import { CreateGroupListing, CreateUserListing, RolesListing } from "../container/userManagement";
import { isAuthenticated } from "../helper";

import CreateProject from "../container/createProject/CreateProject";
import Dashboard from "../container/Dashboard/Dashboard";
import Success from "../container/createProject/Success";
import ProjectPreview from "../container/createProject/ProjectPreview";
import ProjectDetails from "../container/projectDetails";
import IssueDetailPage from "../container/issueDetail/IssueDetailPage";
import IssueList from "../container/issueList/IssueList";
import ProjectList from "../container/projectList/ProjectList";
import CreateAgenda from "../container/createAgenda/CreateAgenda";
import AgendaList from "../container/createAgenda/AgendaList";
import AgendaDetails from "../container/agendaDetails/AgendaDetails";
import Mis from "../container/mis/Mis";
import Profile from "../container/profile/Profile";
import ChangePassword from "../container/profile/ChangePassword";
import ServerError from "../component/ServerError";
import SomethingWentWrong from "../component/SomethingWentWrong";
import GetOtp from "../container/profile/GetOtp";
import PageNotFound from "../component/PageNotFound";
import CommonLayout from "../component/CommonLayout";
import Cms from "../container/cms";
import PragatiList from "../container/PRAGATI/PRAGATI";
import PragatiDetails from "../container/PRAGATIDetail/PragatiDetails";
class PrivateRoutes extends Component {
  render() {
    return <Route
      {...this.props}
      render={props => isAuthenticated() ? (
          <Switch>
            <CommonLayout
              exact
              path={PATHS.CREATE_GROUP_MANAGEMENT}
              component={CreateGroupListing}
            />
            <CommonLayout
              exact
              path={PATHS.CREATE_USER_MANAGEMENT}
              component={CreateUserListing}
            />
            <CommonLayout
              exact
              path={PATHS.CREATE_ROLES_MANAGEMENT}
              component={RolesListing}
            />
            <CommonLayout
              exact
              path={PATHS.PROJECT_DETAILS}
              component={ProjectDetails}
            />
            <CommonLayout
              exact
              path={PATHS.IIG_PROJECT_DETAIL}
              component={CreateProject}
            />
            <CommonLayout
              exact
              path={PATHS.ISSUE_DETAIL}
              component={IssueDetailPage}
            />
            <CommonLayout
              exact
              path={PATHS.ISSUE_LIST}
              component={IssueList}
            />
            <CommonLayout
              exact
              path={PATHS.PROJECT_LIST}
              component={ProjectList}
            />
            <CommonLayout
              exact
              path={PATHS.CREATE_PROJECT}
              component={CreateProject}
            />
            <CommonLayout
              exact
              path={PATHS.PREVIEW}
              component={ProjectPreview}
            />
            <CommonLayout exact path={PATHS.SUCCESS} component={Success} />
            <CommonLayout
              exact
              path={PATHS.CREATE_AGENDA}
              component={CreateAgenda}
            />
            <CommonLayout
              exact
              path={PATHS.AGENDA_LIST}
              component={AgendaList}
            />
            <CommonLayout
              exact
              path={PATHS.AGENDA_DETAILS}
              component={AgendaDetails}
            />
            <CommonLayout exact path={PATHS.MIS} component={Mis} />
            {/* <CommonLayout exact path={PATHS.WORKFLOW} component={Workflow} />*/}
            <CommonLayout
              exact
              path={PATHS.GROUP_MANAGEMENT}
              component={GroupManagement}
            />
            <CommonLayout exact path={PATHS.CMS} component={Cms} />
            <CommonLayout exact path={PATHS.PRAGATI_LISTING_PAGE} component={PragatiList} />
            <CommonLayout exact path={PATHS.PRAGATI_DETAILS_PAGE} component={PragatiDetails} />
            <CommonLayout exact path={PATHS.PROFILE} component={Profile} />
            <CommonLayout
              exact
              path={PATHS.CHANGE_PASSWORD}
              component={ChangePassword}
            />
            <CommonLayout exact path={PATHS.GET_OTP} component={GetOtp} />
            <CommonLayout
              exact
              path={PATHS.DASHBOARD}
              component={Dashboard}
            />
            <CommonLayout component={PageNotFound} />
            <CommonLayout
              exact
              path={PATHS.SERVER_ERROR}
              component={ServerError}
            />
            <CommonLayout
              exact
              path={PATHS.SOMETHING_WENT_WRONG}
              component={SomethingWentWrong}
            />
          </Switch>
        ) : (
          <Redirect
            to={{
              pathname: PATHS.LOGIN,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  }
}

export default PrivateRoutes;
